module.exports = __webpack_public_path__ + "h5/img/home_logo.2c3ee2e6.png";